import { Typography } from "@mui/material";

export const chipOrderStatus = (status) => {

    const ORDER_STATUS_CFG = {
        Arrived: { bg: "#DCFCE7", fg: "#15803D" }, // emerald green   — delivered, positive
        Confirmed: { bg: "#DBEAFE", fg: "#1D4ED8" }, // royal blue      — processing, neutral-positive
        Pending: { bg: "#FEF9C3", fg: "#A16207" }, // warm amber      — waiting, caution
        Shipped: { bg: "#E0F2FE", fg: "#0369A1" }, // sky blue        — in motion, informational
        Forfeited: { bg: "#FFE4E6", fg: "#BE123C" }, // rose red        — loss, strong negative
        Disposed: { bg: "#F3F4F6", fg: "#374151" }, // cool slate grey — neutral / inactive
        Cancelled: { bg: "#FEE2E2", fg: "#DC2626" }, // soft red        — negative, clear stop
        In_Transit: { bg: "#FFF7ED", fg: "#C2410C" }, // deep orange     — moving, warm urgency
    };

    const osCfg = ORDER_STATUS_CFG[status] ?? { bg: "#F3F4F6", fg: "#374151" };

    return (
        <Typography style={{
            display: "inline-flex",
            padding: "2px 8px",
            borderRadius: 3,
            fontSize: 11,
            fontWeight: 700,
            backgroundColor: osCfg.bg,
            color: osCfg.fg,
            whiteSpace: "nowrap",
        }}>
            {
                status === "In_Transit"
                    ? "In Transit"
                    : status
            }
        </Typography>
    );
};